import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { formatTimerDisplay } from '../../lib/utils/time';

var root = $.from_html(`<span> </span>`);

function Timer($$anchor, $$props) {
	$.push($$props, true);

	let size = $.prop($$props, 'size', 3, 'lg');
	let elapsed = $.state(Date.now() - $$props.startTime);

	$.user_effect(() => {
		const interval = setInterval(
			() => {
				$.set(elapsed, Date.now() - $$props.startTime);
			},
			1000
		);

		return () => clearInterval(interval);
	});

	var span = root();
	var text = $.child(span, true);

	$.reset(span);

	$.template_effect(
		($0) => {
			$.set_class(span, 1, `timer timer-${size() ?? ''}`, 'svelte-2ga095o52kjqv');
			$.set_text(text, $0);
		},
		[() => formatTimerDisplay($.get(elapsed))]
	);

	$.append($$anchor, span);
	$.pop();
}

if (import.meta.hot) {
	Timer = $.hmr(Timer);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-2ga095o52kjqv');
		Timer[$.HMR].update(module.default);
	});
}

export default Timer;
import "bun-svelte:Timer.svelte-1wrjhg58greub-style.css";